<template>
  <Content @back="back">
    <template v-slot:nav_left>球员搜索</template>
    <template v-slot:content_right>
      <div class="search-wrap" ref="searchWrap">
        <div class="search">
          <div class="wrap">
            <input v-model.trim="seacherString"
              type="text"
              placeholder="请输入球员姓名或身份有效证件号"
              @keyup.enter="getRequest(true)">
            <div v-show="seacherString!==''"
              class="close"
              @click="seacherString = '';hideSearch = false">
              <v-icon name="regular/times-circle"
                scale="1.2"></v-icon>
            </div>
          </div>
          <div class="searchBtn"
            @click="getRequest(true)">查询
          </div>
        </div>
      </div>
      <div v-show="hideSearch" style="margin-top:20px">
        <div class="list_wrap" style="height: 472px">
          <yioks-loading v-if="isLoading"></yioks-loading>
          <template v-if="!isLoading">
            <div v-if="showList" class="table">
              <div class="thead">
                <div class="tr">
                  <div class="th seq"><strong>序号</strong></div>
                  <div class="th idName"><strong>球员名字</strong></div>
                  <div class="th unionName"><strong>单位</strong></div>
                  <div class="th idNumber"><strong>身份证号</strong></div>
                  <div class="th gender"><strong>性别</strong></div>
                  <div class="th age"><strong>年龄段</strong></div>
                  <div class="th opt"><strong>操作</strong></div>
                </div>
              </div>
              <div class="scrollArea">
                <vue-scroll >
                  <div class="tbodyWrap">
                    <div class="tbody">
                      <div v-for="(item, index) in playerList" :key="index" class="tr">
                        <div class="td seq">
                          <p>{{ index + 1 }}</p>
                        </div>
                        <div class="td idName">
                          <p>{{ item.idName }}</p>
                        </div>
                        <div class="td unionName">
                          <p :title="item.workName">{{ item.workName }}</p>
                        </div>
                        <div class="td idNumber">
                          <p>{{ item.idNumber | filterIdNumberPrivacy }}</p>
                        </div>
                        <div class="td gender">
                          <p>{{ item.gender || '--' }}</p>
                        </div>
                        <div
                          class="td age"
                        >
                          <p v-if="item.birthday">
                            {{ item.birthday| timeYear}}
                          </p>
                          <p v-else>--</p>
                        </div>
                        <div class="td opt">
                          <p>
                            <span class="item" @click="goDetail(item.uuid)">查看</span>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </vue-scroll>
              </div>
            </div>
            
          </template>
          <yioks-empty v-show="showEmpty" />
        </div>
        <Pagination :total="total" :pageSize="pageSize" :page.sync="page"/>
      </div>
    </template>
  </Content>
</template>

<script>

import 'vue-awesome/icons/regular/edit'
import { centerStatus } from '@/utils/yioks_filter'
import mixinAppConfig from "@/mixin/mixinAppConfig";
import {ops} from "@/utils/scrollIndialog";
import player from "@/api/player";
import { filterIdNumber, getAgeFromIdNumberYear } from "@/utils/yioks_filter";
import { idCard_number } from "@/assets/js/formRules";
import storage from '@/utils/storage';
/* 搜索框叉号 */
import "vue-awesome/icons/regular/times-circle";
export default {
  mixins: [mixinAppConfig],
  components: {
    'Content': () => import('@/components/layout/list'),
    'Pagination': () => import('@/components/Pagination'),
  },
  filters: {
    filterIdNumber,
    getAgeFromIdNumberYear,
    formateAge(val) {
      if(val) {
        if(idCard_number(val)) {
          return getAgeFromIdNumberYear(val)
        } else {
          return '--'
        }
      } else {
        return '--'
      }
    },
    formateAgeFromNow(val) {
      if(!val) {
        return '--'
      } else {
        const moment = require('moment');
        const years = moment(val).format('yyyy');
        const nowYear = new Date().getFullYear();
        return (nowYear - Number(years))
      }
    },
  },
  data () {
    return {
      ops,
      seacherString:'',
      hideSearch: false,
      isLoading: false,
      showList: false,
      showEmpty: false,
      playerList:[],
      userRole:storage.get('userInfo').userRole,
      total: 0,
      page: 0,
      pageSize: 20,
    }
  },
  watch: {
    page () {
      this.getRequest()
    },
    hideSearch(val) {
      if(val) {
        this.$refs.searchWrap.style.height = '40px'
        this.$refs.searchWrap.style.marginTop = '20px'
      } else {
        this.$refs.searchWrap.style.height = '100%'
        this.$refs.searchWrap.style.marginTop = '0'
      }
    }
  },
  created () {
    const { page, seacherString } = this.$route.query
    page && (this.page = Number(page))
    this.seacherString = seacherString || ''
    this.getRequest()
  },
  methods: {
    goDetail(uuid) {
      this.$router.push({
        path: "info",
        query: {
          uuid,
        },
      });
    },
    back(){
      if ( this.userRole === "admin"){
        this.$router.push('/home/index?details=mans')
      }else {
        this.$router.push('/home')
      }
    },
    getRequest (flag) {
      if (flag) this.page = 0
      if (!this.seacherString){
        this.hideSearch = false
        return
      }
      this.hideSearch = true
      this.isLoading = true
      this.showList = false
      this.showEmpty = false
      // 保存 key
      this.$router.replace({
        path: this.$route.path,
        query:{
          page: this.page,
          seacherString: this.seacherString
        }
      })
      let request;
      if (this.userRole === "system" || this.userRole === "admin"|| this.userRole === "expert") {
        request = player.getPlayerSystem;
      } else if (this.userRole === "organ") {
        request = player.getPlayerOrgan;
      } else if (
        this.userRole === "youth" ||
        this.userRole === "trainCamp" ||
        this.userRole === "club"
      ) {
        request = player.getPlayerYouth;
      } else if (this.userRole === "leader" || this.userRole === "coach") {
        request = player.getPlayerLeaderOrCoach;
      }
      
      request({ page: this.page, size: this.pageSize,organUuid:'',youthUuid:'',squadUuid:'',  seacherString:this.seacherString })
      .then((res) => {
        this.isLoading = false;
        this.total = res.totalElements;
        if (res.content.length) {
          this.playerList = res.content;
          this.showList = true;
        } else {
          this.showEmpty = true;
        }
      })
      .catch((err) => {
        this.isLoading = false;
        console.error(err);
      });
    },
  }
}
</script>

<style lang="stylus" scoped>
  @import '~@/assets/css/variable'
  .navTitle
    padding 10px 20px
    /*margin-right .2rem*/
    cursor pointer
    &:last-child
    &:last-child
      margin-right 0
    &.active
      background $green_color
      color #FFF
  .search-wrap
    display flex
    align-items center
    justify-content center
    height 100%
    .search {
      height: 40px;
      display: flex;
      align-items: center;
      .wrap {
        height: 100%;
        position: relative;
        input {
          width: 450px;
          height: 100%;
          padding: 0 20px;
          font-size: 16px;
          color: #000000;
          outline: none;
        }
        .close {
          position: absolute;
          right: 5px;
          top: 10px;
          color: $gray_color;
          cursor: pointer;
        }
      }
      .searchBtn {
        width: 90px;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 20px;
        background-color: $green_color;
        cursor: pointer;
      }
    }
  .list_wrap
    flex 1
    overflow hidden
    .table {
      display flex
      flex-direction column
      flex 1
      width: 100%;
      // margin: 30px 0 0;
      .thead, .tbody {
        border: 1px solid $color_white;
      }
      .thead {
        margin: 0 40px;
        .tr {
          height: 45px;
          display: flex;
        }
      }
      .scrollArea {
        height: 425px;
        padding-bottom:15px
        /*flex 1 */
        /*overflow hidden*/
      }
      .tbodyWrap {
        display block
        // padding: 0 40px;
      }
      .tbody {
        display block
        width 810px
        margin-left auto
        margin-right auto
        max-width: 810px;
        border-top: none;
        border-bottom: none;
        .tr {
          height: 49px;
          display: flex;
          border-bottom: 1px solid $color_white;
        }
      }
      .th, .td {
        height: 100%;
        /*flex: 1 1 auto;*/
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: $font_size_medium;
        border-right: 1px solid $color_white;
      }
      .th:last-child, .td:last-child {
        border-right: none;
      }
      .td {
        p {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          color: $color_white;
        }
      }
      .seq{
        width 7%
      }
      .idName{
        width 12%
      }
      .idNumber{
        width: 21%;
      }
      .gender, .age{
        width:7%;
      }
      .unionName{
        width 36%
        p {
          padding 0 4px
        }
      }
      .opt{
        width: 10%;
        p{
          width 100%
          text-align center
          .item{
            cursor: pointer;
            user-select: none;
            color $green_color
          }
          .split{
            margin 0 5px
          }
        }
      }
      .optExpert{
        width: 22.5%;
        p{
          width 100%
          text-align center
          .item{
            cursor: pointer;
            user-select: none;
            color $green_color
          }
          .split{
            margin 0 5px
          }
        }
      }
    }
  .tip
    margin-top 10px
    color red
    width 100%
    text-align center
    word-break break-word
</style>


